import { FormValidator, ValidationRules } from 'src/utils/FormValidator';

export const ProfileSettingsValidationPaths = {
  BUSINESS_UNIT: {
    path: 'businessUnit',
    message: 'Error: Please select a Business Unit.',
  },
  LOCATION: {
    path: 'locations',
    message: 'Error: Please select a Location.',
  },
} as const;

export const ProfileSettingsValidator = (locationCount: number = 0): FormValidator => {
  const validator = new FormValidator();

  validator.addRule(
    ProfileSettingsValidationPaths.BUSINESS_UNIT.path,
    ValidationRules.required,
    ProfileSettingsValidationPaths.BUSINESS_UNIT.message,
  );
  if (locationCount > 0) {
    validator.addRule(
      ProfileSettingsValidationPaths.LOCATION.path,
      ValidationRules.required,
      ProfileSettingsValidationPaths.LOCATION.message,
    );
  }

  return validator;
};
